<template>
    <div id="document-top">
        <ListDocumentFromS3></ListDocumentFromS3>
      <UploadDocuments></UploadDocuments>
      <ApplicantDocumentRequests></ApplicantDocumentRequests>
      <floating-comment-section v-model="application" :available-sections="availableSections" :current-sections="currentSections" />
    </div>
</template>

<script>
import ListDocumentFromS3 from "../components/Docs/ListDocumentFromS3";
import ApplicantDocumentRequests from '../components/Docs/ApplicantDocumentRequests';
import UploadDocuments from "../components/Docs/UploadDocuments";
import FloatingCommentSection from '@/components/Editors/FloatingCommentSection';
import {mapGetters} from "vuex";

export default {
    components: {
      UploadDocuments,
        ListDocumentFromS3,
      ApplicantDocumentRequests,
      FloatingCommentSection,
    },
    data() {
        return {
            error:null,
          availableSections: [
            'Documents',
            'Wallet Notification'
          ],
          currentSections: 'Documents'
        };
    },
    methods: {},
    filters: {},
  mounted() {
    //scroll to the top when the element is mounted
    this.$scrollTo('#document-top', {container: ".scroll-area"})
  },
  computed: {
    ...mapGetters([
      "application",
    ]),
  },
};
</script>
<style scoped>
.errorAlert{
    background-color:red;
    color:white;
}

.md-ripple > span {
    position: relative;
}
</style>
